// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1jeCv","clinicsSelect":"styles_clinicsSelect__173zO"};